module.exports = __webpack_public_path__ + "static/img/banner19.f14dc3e6.png";